import React from 'react'

import PropTypes from 'prop-types'

import './button.css'

const Button = (props) => {
  return (
    <div className="button-container">
      <a
        href="https://wa.me/65992993749"
        target="_blank"
        rel="noreferrer noopener"
        className="button-button"
      >
        <img
          alt={props.vectorAlt}
          src={props.vectorSrc}
          className="button-vector"
        />
      </a>
    </div>
  )
}

Button.defaultProps = {
  vectorSrc: '/external/vectori374-fc5.svg',
  vectorAlt: '',
}

Button.propTypes = {
  vectorSrc: PropTypes.string,
  vectorAlt: PropTypes.string,
}

export default Button
